import React, { useState } from 'react';
import Table from '../../../components/Table';
import Loader from '../../../components/Loader';
import { columns } from './columns';
import { usePolywizzContext } from '../context';
import { TaxReturnForList } from '../../../interfaces/taxReturn';
import { editTaxReturn } from '../../../utils/api/taxReturn';
import EditTaxReturnModal from '../modals/EditTaxReturn';
import globalErrorHandler from '../../../utils/globalErrorHandler';
import { Polywizz } from '../../../interfaces/Insurance';

const PolywizzTable = () => {
    const { loading, polywizzItems, setPolywizzItems, total, filterConfigs, t } = usePolywizzContext();
    const { onSortChanged, setPage, page, MAX_ITEMS_PER_PAGE } = filterConfigs;

    const paginationProps = {
        onPageSelected: (page: number) => {
            setPage(page);
        },
        startPage: page,
        totalItems: total,
        numberOfPages: Math.ceil(total / MAX_ITEMS_PER_PAGE),
    };

    return (
        <div className="polywizz-table">
            {loading ? (
                <Loader />
            ) : (
                <>
                    <Table
                        columns={columns}
                        data={polywizzItems}
                        total={total}
                        isSortable={true}
                        onSortChanged={onSortChanged}
                        paginationProps={paginationProps}
                        pagination={true}
                        pageSize={MAX_ITEMS_PER_PAGE}
                        translationFunction={t}
                    />
                </>
            )}
        </div>
    );
};

export default PolywizzTable;
